<template>
    <div class="index-view">
        <Header></Header>
        <div class="app-main">
            <transition name="fade-transform" mode="out-in">
                <keep-alive :include="cachedViews">
                    <router-view v-if="!$route.meta.link" :key="key" />
                </keep-alive>
            </transition>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from './footer.vue';
import Header from './header.vue';
export default {
    name: 'IndexView',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            cachedViews: ["/pay"],
        }
    },
    computed: {
        key() {
            return this.$route.path
        }
    }
}
</script>
<style scoped lang="scss">
.index-view {
    overflow-x: hidden;
}
</style>